// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"gQ-z","categoryName":"hQ-z","categoryNameSearchHeader":"iQ-z","categoryContent":"jQ-z","bottomAligned":"kQ-z","image":"lQ-z","imageNoBackground":"mQ-z"};